/* eslint-disable react/self-closing-comp */
/* eslint-disable react/button-has-type */
import React from 'react';

const Button = props => {
  const {
    id,
    name,
    btnText,
    className = '',
    click,
    type = 'text',
    loader = false,
    icon = false,
    iconName = '',
    svg = false,
    disabled = false,
    form,
    isHtmlBtnContent = false,
    HtmlBtnContent,
  } = props;

  return (
    <button
      id={id}
      form={form}
      name={name}
      disabled={disabled}
      type={type}
      className={`animatedButton ${className}${
        loader && !className.includes('loading') ? ' loading' : ''
      }`}
      onClick={click}
    >
      {svg && !loader && <span className="iconStart">{svg}</span>}
      {loader && <span className="load-text"></span>}
      {!loader && !isHtmlBtnContent && <span>{btnText}</span>}
      {!loader && isHtmlBtnContent && <HtmlBtnContent />}
      {icon && <i className="material-icons-outlined">{iconName}</i>}
    </button>
  );
};

export default Button;
